import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-radio-input',
    standalone: false,
    templateUrl: './radio-input.component.html',
    styleUrl: './radio-input.component.scss',
})
export class RadioInputComponent extends InputComponent {}
